import { ADD_DONATION_ITEM, COUPON_DATA, DONATION_DATA, DONATION_ITEMS, GET_CART, HANDLE_ALT_NUM, HANDLE_SPECIAL_INPUT,RESET_CUS_DONATION,SAVE_DISCOUNT, UPDATE_DONATION_ITEM } from "../actions/cartTypes";

const initialState: any = {
    cartData: [] || "",
    coupon: {},
    special_instructions: "",
    alternate_number: "",
    discountAmount: 0,
    comboVoucher:null,
    couponReady: true,
    cartQty:0,
    donationData: [],
    donationItems: [],
}
const cartReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_CART:
            let qty = 0;
            for (let i = 0; i < action.payload.length; i++){
                qty += action.payload[i].quantity?action.payload[i].quantity:0
            }
            return {
                ...state,
                cartData: action.payload,
                cartQty:qty
            };
        case COUPON_DATA:
            return {
                ...state,
                coupon: action.payload,
                comboVoucher:action.comboVoucher,
                couponReady:action.couponReady
            };
        case RESET_CUS_DONATION:
            return {
                ...state,
                donationItems: []
            };
        case HANDLE_SPECIAL_INPUT: return {
            ...state,
            special_instructions: action.input
        }
        case HANDLE_ALT_NUM: return {
            ...state,
            alternate_number: action.input
        }
        case SAVE_DISCOUNT:
            return {
                ...state,
                discountAmount: action.discountValue,
            };
        case DONATION_DATA:
            return {
                ...state,
                donationData: action.payload,
            };
        case DONATION_ITEMS:
            return {
                ...state,
                donationItems: action.payload,
            };
        case ADD_DONATION_ITEM:
            const newDonationItem = {
                donation_id: action.payload.donation_id,
                quantity: action.payload.quantity,
                price: action.payload.price,
                totalItemPrice: action.payload.totalItemPrice,
            };
            return {
                ...state,
                donationItems: [...state.donationItems, newDonationItem],
            }
        case UPDATE_DONATION_ITEM:
            const updatedDonationItems = state.donationItems.map((item: any) => {
                if (item.donation_id === action.payload.donation_id) {
                    return {
                        ...item,
                        quantity: item.quantity + action.payload.quantity,
                        totalItemPrice: item.totalItemPrice + action.payload.totalItemPrice,
                    };
                }
                return item;
            });
            return {
                ...state,
                donationItems: updatedDonationItems,
            };
        default: return state;
    }
}
export default cartReducer;